import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from '../../../app/servicios/api/api.service';
import { AdminFuenteService } from '../../servicios/adminfuentes/AdminFuente.service';
import { fuenteI } from '../../../app/modelos/fuentes.interface';
import { OperacionI } from '../../../app/modelos/operacionEsta.interface';

@Component({
  selector: 'app-variableschv',
  templateUrl: './variableschv.component.html',
  styleUrls: ['./variableschv.component.css']
})
export class VariableschvComponent implements OnDestroy,OnInit {

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  Operacion:OperacionI;
  fuentesChv : fuenteI[];

  constructor(
    private api:ApiService,
    private adminFuenteService: AdminFuenteService,
    private router:Router
    ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ entradas"
        }
    };

    let operacion: OperacionI;
    operacion = new OperacionI();
    operacion.id =1;
    operacion.descripcion= "Cartera Hipotecaria de Vivienda";
    operacion.nombre = "CHV";

    this.adminFuenteService.getFuentesByOpe(1).subscribe(data=>{
      this.dtTrigger.next();
      this.fuentesChv = data;
      for (let fte of this.fuentesChv){
        this.api.getdeptoByCod(fte.depto).subscribe(depto0=>{
          fte.depto = depto0.nombre;
        });
        this.api.getMuniByCodigo(fte.muni).subscribe(muni0=>{
          fte.muni = muni0.nommpio;
        });
      }
    },error=>{
      console.log(error);
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  goAdminVaribles(id){
    this.router.navigate(['administrarvariableschv', id]);
  }

  regresarDirectorio(){
    this.router.navigate(['directorio']);
  }

}
